<template>
  <div class="main">
    <div class="form-row">
      <div class="form-field">
        <label for="reg-fio-input">ФИО:</label>
        <input id="reg-fio-input" v-model="regData.fio" type="text" />
      </div>
      <div class="form-field">
        <label for="reg-phone-input">Телефон:</label>
        <input id="reg-phone-input" v-model="regData.phone" type="text" />
      </div>
      <div class="form-field">
        <label for="reg-email-input">Email:</label>
        <input id="reg-email-input" v-model="regData.email" type="text" />
      </div>
      <div class="form-field">
        <label for="reg-password-input">Пароль:</label>
        <input
          id="reg-password-input"
          v-model="regData.password"
          type="password"
        />
      </div>
      <div class="form-field">
        <img v-show="waite" src="@/assets/wait.gif" class="waite" alt="" />
        <button v-show="!waite" @click="sendRegisterData">
          Зарегистрироваться
        </button>
      </div>
    </div>
    <div class="form-row" v-if="info">{{ info }}</div>
    <div class="form-row" v-if="token">
      <div class="form-field">
        <label for="reg-key-input">Введите код:</label>
        <input id="reg-key-input" v-model="phoneKey" type="text" />
        <button v-show="!waite" @click="confirmKey">Подтвердить</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "@/config";

export default {
  name: "Register",
  data() {
    return {
      url: config.backend_url,
      regData: {
        fio: null,
        phone: null,
        email: null,
        password: null
      },
      phoneKey: null,
      userId: false,
      token: false,
      info: false,
      waite: false
    };
  },
  methods: {
    sendRegisterData: function() {
      let self = this;
      if (
        self.regData.fio !== null &&
        self.regData.phone !== null &&
        self.regData.email !== null &&
        self.regData.password !== null
      ) {
        self.waite = true;
        axios
          .post(self.url + "users/add/", {
            data: self.regData
          })
          .then(function(response) {
            let data = response.data;
            if (data.error) {
              self.info = data.error;
            } else {
              self.userId = data.userId;
              if (data.smsId) {
                self.token = data.token;
                self.info = "На Ваш номер отправили код подтверждения";
              } else {
                self.info = "Ошибка отправки СМС: " + data.smsError;
              }
            }
            self.waite = false;
          });
      } else {
        self.info = "Необходимо заполнить все поля";
      }
    },
    confirmKey: function() {
      let self = this;
      let activateData = {};
      activateData.key = this.phoneKey;
      activateData.userId = this.userId;
      activateData.token = this.token;
      axios
        .post(self.url + "users/activate/", {
          data: activateData
        })
        .then(function(response) {
          let data = response.data;
          if (data.error) {
            self.info = data.error;
          } else {
            self.info = data.success;
          }
        });
    }
  },
  mounted() {}
};
</script>
